import { ICheckPaymentByProviderResponse } from '../../../../repositories/billing-payments/v1/check-payment-by-provider';
import { EPaymentStatus } from '../../../../types/reducers/depositAccount';
import { IPaymentStatus } from '../types';

export const mapResponse200 = (response: ICheckPaymentByProviderResponse): IPaymentStatus => {
  const { status } = response;

  return { status: status as string as EPaymentStatus, message: null };
};
